import Head from 'next/head';
import Typography from '@/components/Typography';

const Page: React.FC = () => {
  return (
    <>
      <Head>
        <title>Typographie</title>
      </Head>
      <Typography />
    </>
  );
};

export default Page;
